module.exports = __webpack_public_path__ + "img/first1.a6415b07.svg";